var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreOpeningTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h28v28H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.25 18.89.64-.64-4.42-4.44V8.28h-.86v5.91l4.64 4.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.21 10.11a10.19 10.19 0 0 0-5.33-5.32 9.866 9.866 0 0 0-7.76 0 10.19 10.19 0 0 0-5.32 5.33 9.866 9.866 0 0 0 0 7.76 10.19 10.19 0 0 0 5.33 5.32c1.22.53 2.54.8 3.88.79 1.34.01 2.66-.26 3.89-.79a10.19 10.19 0 0 0 5.32-5.33 9.866 9.866 0 0 0 0-7.76Zm-2.75 10.35A8.781 8.781 0 0 1 14 23.14c-2.43.04-4.77-.93-6.46-2.68A8.781 8.781 0 0 1 4.86 14c-.04-2.43.93-4.77 2.68-6.46A8.781 8.781 0 0 1 14 4.86c2.43-.04 4.77.93 6.46 2.68A8.781 8.781 0 0 1 23.14 14c.04 2.43-.93 4.77-2.68 6.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreOpeningTimes);
export default __webpack_public_path__ + "static/media/Store Opening Times.aae865b8ddb1a4a5aa8f1a64ace45ba2.svg";
export { ForwardRef as ReactComponent };